export default {
    'contact': 'Kontakt',
    'find-us': 'Znajdź nas',
    'implementation': 'Wykonanie',
    'media-center': 'Centrum Mediów AGH',
    'ui-design': 'Projekt graficzny'
}
